import { getSessao } from './auth';

export async function fetchAutenticado(url: string, options: RequestInit = {}): Promise<Response> {
  const sessao = getSessao();
  const headers = new Headers(options.headers);

  if (sessao?.token) {
    headers.set('Authorization', `Bearer ${sessao.token}`);
  }

  // Para FormData (uploads multipart), NÃO definir Content-Type — o browser
  // gera o boundary automaticamente. Forçar application/json quebra o parse.
  if (options.body && !(options.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(url, { ...options, headers });
}
